'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { ATTACHED_TO_LANGUAGE_MASTER } from '../actions/ActionTypes';
import { closeModal } from '../actions/ModalActions';
import { receiveContent, requestAttachToLanguageMaster, requestedAttachToLanguageMasterFailure, requestedAttachToLanguageMasterSuccess } from '../actions/ContentActions';
export default ((action$, _, {
  ContentClient
}) => action$.ofType(ATTACHED_TO_LANGUAGE_MASTER).pipe(mergeMap(({
  payload: {
    contentType,
    id,
    language,
    translatedFromId
  }
}) => ContentClient.attachToLanguageMaster(contentType, id, language, translatedFromId).pipe(mergeMap(content => of(receiveContent(content), closeModal(), requestedAttachToLanguageMasterSuccess(contentType))), catchError(error => of(requestedAttachToLanguageMasterFailure(error, contentType))), startWith(requestAttachToLanguageMaster())))));